export const etatPanierActualiseProps = () => ({
  etatPanier: {
    type: Object,
    required: true
  },
  indisponibles: {
    type: Array,
    required: false,
    default: () => { return [] }
  },
  quantiteInsuffisante: {
    type: Array,
    required: false,
    default: () => { return [] }
  }
})